export enum RequestType {
    Overall = 'Overall',
    KYB = 'KYB',
    FirstParty = 'First party',
    Synthetic = 'Synthetic',
    ThirdParty = 'Third party'
}

export interface Verification {
    id: string;
    business_name: string;
    created_at: string;
    status: string;
    risk_score: number;
    tenant_name: string;
}

export interface VerificationsResponse {
    verifications: Verification[];
    total: number;
}

export interface ApplicantInformation {
    first_name: string;
    last_name: string;
    email: string;
    phone: string;
    date_of_birth?: string;
    last_4_ssn?: string;
    role?: string;
};
export interface CreateVerificationPayload {
    request_type: RequestType[];
    business: {
        legal_name: string;
        address: {
            street_line_1: string;
            street_line_2?: string;
            city: string;
            state: string;
            zip_code: string;
            country: string;
            website?: string;
            ein?: string;
        };
    };
    applicants: ApplicantInformation[];
}
export interface CreateVerificationResponse {
    id: string;
    business_name: string;
    status: string;
    created_at: string;
    request_type: RequestType[];
}

export interface BulkUploadResponse {
    total_rows: number;
    processed_successfully: number;
    skipped_rows: number;
    successful_verifications: string[];
    errors: string[];
}
